@if (!item()?.hidden) {
  @if (item().url && !item().external) {
    <li
      [ngClass]="item().classes"
      [routerLinkActive]="['active']"
      ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}"
    >
      <a
        class="nav-link"
        [target]="item().target ? '_blank' : '_self'"
        [routerLink]="[item().url]"
        (click)="closeOtherMenu($event)"
        [ngClass]="{ disabled: !isEnabled }"
      >
        @if (!isEnabled) {
          <span class="pcoded-micon" [ngClass]="{ disabled: !isEnabled }">
            <i class="feather icon-lock f-16"></i>
          </span>
        } @else {
          <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
        }

        @if (item().icon) {
          <span class="pcoded-mtext">{{ item().name | translate }}</span>
        } @else {
          {{ item().name | translate }}
        }
        <ng-template #directTitle>
          {{ item().name | translate }}
        </ng-template>
        <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
      </a>
    </li>
  }
  @if (item().url && item().external) {
    <li [ngClass]="item().classes" ngbTooltip="{{ !isEnabled ? 'You do not have permission to access this page ' : '' }}">
      <a [target]="item().target ? '_blank' : '_self'" [href]="item().url" [ngClass]="{ disabled: !isEnabled }">
        @if (!isEnabled) {
          <span class="pcoded-micon" [ngClass]="{ disabled: !isEnabled }">
            <i class="feather icon-lock f-16"></i>
          </span>
        } @else {
          <ng-container *ngTemplateOutlet="itemIcon"></ng-container>
        }
        @if (item().icon) {
          <span class="pcoded-mtext">{{ item().name | translate }}</span>
        } @else {
          {{ item().name | translate }}
        }
        <ng-template #directTitle>
          {{ item().name | translate }}
        </ng-template>
        <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
      </a>
    </li>
  }
  <!-- <ng-template #itemIcon>
    @if (item().icon) {
      <span class="pcoded-micon"><i class="feather" [ngClass]="item().icon"></i></span>
    }
  </ng-template> -->
  <ng-template #itemBadge>
    @if (item().badge && themeLayout === 'vertical') {
      <span class="pcoded-badge label" [ngClass]="item().badge.type">
        {{ item().badge.name | translate }}
      </span>
    }
    @if (item().badge && themeLayout === 'horizontal') {
      <span class="badge label" [ngClass]="item().badge.type">
        {{ item().badge.name | translate }}
      </span>
    }
  </ng-template>
}
